import styled from '@emotion/styled';
import { ButtonHTMLAttributes } from 'react';
import ArrowLeft from '~/icons/iconography/arrow/left.svg';
import ArrowRight from '~/icons/iconography/arrow/right.svg';

type Props = {
    orientation: 'left' | 'right';
} & ButtonHTMLAttributes<HTMLButtonElement>;

export default function ArrowButton({ orientation, ...rest }: Props) {
    return <Button {...rest}>{orientation === 'left' ? <ArrowLeft /> : <ArrowRight />}</Button>;
}

export const Button = styled.button(({ theme }) => ({
    cursor: 'pointer',
    border: 'none',
    height: theme.space[6],
    width: theme.space[6],
    backgroundColor: theme.colors.brandBlue,
    borderRadius: theme.space[1],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&:disabled': {
        cursor: 'default',
        backgroundColor: theme.colors.grey50,
    },

    svg: {
        width: theme.space[4],
        height: theme.space[4],
        color: theme.colors.white,
    },
}));
